<main>
	<h1>{{consumerKey}}</h1>
	<button routerLink="./{{configDataService.RESERVED_NEW_CONFIG_KEY}}">Create New Config</button>
	<ul>
		<li *ngFor="let config of configList">
			<a routerLink="./{{stringUtil.encode(config.ConfigKey)}}">
				{{config.ConfigKey}}
			</a>
		</li>
	</ul>
</main>